/* ============================================================
   product-hero.js — 产品页 hero（图库轮播 + 变体选择）
   对应 sections/product-hero.liquid（同名拆分）。
   - 图库：缩略图/箭头/键盘/拖拽切换
   - 变体：swatch 选色 → 更新价格与按钮 data-variant-id；
     未选色点购买时提示（theme.js 对空 variant-id 自动忽略，二者不冲突）
   - ?variant=ID 深链：按 URL 参数反查颜色并选中（通用，不写死 ID）
   ============================================================ */
(function () {
  'use strict';

  function initSection(root) {
    /* ── 图库轮播 ─────────────────────────────────────────── */
    var gallery = root.querySelector('[data-ph-gallery]');
    var track = root.querySelector('[data-ph-track]');
    var thumbs = Array.from(root.querySelectorAll('[data-ph-thumb]'));
    var slides = track ? Array.from(track.children) : [];
    var total = slides.length;
    var cur = 0;
    var startX = 0;
    var isDragging = false;
    var dragDist = 0;

    function goTo(idx) {
      if (!total) return;
      cur = (idx + total) % total;
      track.style.transition = 'transform .45s cubic-bezier(0.22,1,0.36,1)';
      track.style.transform = 'translateX(-' + cur * 100 + '%)';
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === cur);
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        goTo(parseInt(t.dataset.index, 10));
      });
    });
    var prev = root.querySelector('[data-ph-prev]');
    var next = root.querySelector('[data-ph-next]');
    if (prev) prev.addEventListener('click', function () { goTo(cur - 1); });
    if (next) next.addEventListener('click', function () { goTo(cur + 1); });

    function finishDrag() {
      if (!isDragging && Math.abs(dragDist) < 5) return;
      isDragging = false;
      track.style.transition = 'transform .45s cubic-bezier(0.22,1,0.36,1)';
      if (Math.abs(dragDist) > 60) goTo(dragDist < 0 ? cur + 1 : cur - 1);
      else track.style.transform = 'translateX(-' + cur * 100 + '%)';
      dragDist = 0;
    }

    if (gallery && track) {
      gallery.addEventListener('mousedown', function (e) {
        isDragging = true;
        startX = e.clientX;
        dragDist = 0;
        track.style.transition = 'none';
      });
      gallery.addEventListener('mousemove', function (e) {
        if (!isDragging) return;
        dragDist = e.clientX - startX;
        track.style.transform = 'translateX(calc(-' + cur * 100 + '% + ' + dragDist + 'px))';
      });
      gallery.addEventListener('mouseup', finishDrag);
      gallery.addEventListener('mouseleave', finishDrag);
      gallery.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        dragDist = 0;
        track.style.transition = 'none';
      }, { passive: true });
      gallery.addEventListener('touchmove', function (e) {
        dragDist = e.touches[0].clientX - startX;
        track.style.transform = 'translateX(calc(-' + cur * 100 + '% + ' + dragDist + 'px))';
      }, { passive: true });
      gallery.addEventListener('touchend', finishDrag);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') goTo(cur - 1);
        if (e.key === 'ArrowRight') goTo(cur + 1);
      });
    }

    /* ── 变体选择 ─────────────────────────────────────────── */
    var actions = root.querySelector('.phero__actions');
    var hasSelector = actions && actions.getAttribute('data-has-selector') === 'true';
    var buttons = Array.from(root.querySelectorAll('[data-ph-action]'));
    var colorHint = root.querySelector('[data-ph-color-required]');
    var priceMain = root.querySelector('[data-ph-price]');
    var priceOrig = root.querySelector('[data-ph-price-orig]');
    var selectedLabel = root.querySelector('[data-ph-selected]');
    var soldOutHint = root.querySelector('[data-ph-soldout]');
    var variantByColor = {};
    try {
      variantByColor = JSON.parse(root.querySelector('[data-ph-variants]').textContent || '{}');
    } catch (e) { /* 无变体数据时保持空 */ }

    /* 变体 JSON 一直带 available 字段，但此前从未读取：售罄变体的按钮
       照样可点，点下去被 /cart/add.js 拒掉，只在控制台留下
       "The product '…' is already sold out."，页面上没有任何反馈。
       这里按 available 置灰按钮并给出文案。注意 available 为 undefined
       （老数据 / 解析失败）时按可售处理，不要误伤正常商品。 */
    function applyVariant(entry) {
      var soldOut = !!entry && entry.available === false;
      buttons.forEach(function (btn) {
        btn.setAttribute('data-variant-id', soldOut ? '' : (entry && entry.id) || '');
        btn.disabled = soldOut;
        btn.setAttribute('aria-disabled', soldOut ? 'true' : 'false');
      });
      if (soldOutHint) soldOutHint.hidden = !soldOut;
    }

    function selectSwatch(swatch) {
      root.querySelectorAll('[data-ph-swatch]').forEach(function (s) {
        s.classList.toggle('is-active', s === swatch);
      });
      var color = swatch.dataset.color;
      if (selectedLabel) selectedLabel.textContent = color;
      var entry = variantByColor[color];
      applyVariant(entry);
      if (entry && priceMain) {
        priceMain.textContent = entry.price;
        if (priceOrig) {
          if (entry.compareAt) {
            priceOrig.textContent = entry.compareAt;
            priceOrig.hidden = false;
          } else {
            priceOrig.hidden = true;
          }
        }
      }
      if (colorHint) colorHint.hidden = true;
      if (swatch.dataset.slide !== undefined && swatch.dataset.slide !== '') {
        goTo(parseInt(swatch.dataset.slide, 10) || 0);
      }
    }

    root.querySelectorAll('[data-ph-swatch]').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        selectSwatch(swatch);
      });
    });

    // 未选色时点击购买 → 提示（theme.js 对空 variant-id 不动作）
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!btn.getAttribute('data-variant-id') && colorHint) colorHint.hidden = false;
      });
    });

    if (hasSelector) {
      // ?variant=ID 深链：反查颜色选中；否则默认第一个 swatch
      var deepId = new URLSearchParams(window.location.search).get('variant');
      var target = null;
      if (deepId) {
        Object.keys(variantByColor).forEach(function (color) {
          if (String(variantByColor[color].id) === deepId) {
            target = root.querySelector('[data-ph-swatch][data-color="' + CSS.escape(color) + '"]');
          }
        });
      }
      if (!target) target = root.querySelector('[data-ph-swatch]');
      if (target) selectSwatch(target);
    }
  }

  function init() {
    document.querySelectorAll('[data-product-hero]').forEach(function (root) {
      if (root.dataset.phReady === 'true') return;
      root.dataset.phReady = 'true';
      initSection(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
